import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  GET_PRODUCT,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAILURE,
  EDIT_PRODUCT,
  EDIT_PRODUCT_SUCCESS,
  EDIT_PRODUCT_FAILURE,
  CLEAR_PRODUCT,
  SET_FITER_VALUES,
  SET_SEARCH_VALUE,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAILURE,
  UPLOAD_TEMPLATE,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILURE,
  CLEAR_FILTER_VALUES
} from "../constants/productsActionsType";

import { product as initialState } from "../constants/initialStates";

export const productReducer = (state = initialState, { data, error, type }) => {
  switch (type) {
    case FETCH_PRODUCTS:
      return {
        ...state,
        isLoading: true
      };

    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: data,
        isLoading: false
      };

    case FETCH_PRODUCTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    case GET_PRODUCT:
      return {
        ...state,
        isLoading: true
      };

    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        product: data,
        isLoading: false
      };

    case GET_PRODUCT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    case CLEAR_PRODUCT:
      return {
        ...state,
        product: { images: [] }
      };

    case CLEAR_FILTER_VALUES:
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          // merchant: {},
          // store: {},
          search: "",
          stock_status: {
            value: null,
            label: "Todas"
          }
        }
      };

    case EDIT_PRODUCT:
      return {
        ...state,
        isLoading: true
      };

    case EDIT_PRODUCT_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case EDIT_PRODUCT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    case SET_FITER_VALUES:
      const key = Object.keys(data)[0];
      const value = Object.values(data)[0];
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          [key]: value
        }
      };

    case SET_SEARCH_VALUE:
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          search: data,
          stock_status: {
            value: null,
            label: "Todas"
          }
        }
      };

    case GET_CATEGORIES:
      return {
        ...state,
        isLoading: true
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: data
      };

    case GET_CATEGORIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    case UPLOAD_TEMPLATE:
      return {
        ...state,
        isLoading: true
      };

    case UPLOAD_TEMPLATE_SUCCESS:
      return {
        ...state,
        isLoading: false
      };

    case UPLOAD_TEMPLATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };

    default:
      return state;
  }
};
